var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"home-container"}},[_c('el-container',[_c('el-header',[_c('myHeader')],1),_c('el-container',[_c('el-aside',{attrs:{"width":"210px"}},[_c('leftMenu')],1),_c('el-main',[_c('router-view')],1)],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }